import { GARAGE } from "../data/portfolio";

const GarageSection = () => (
  <section className="section-enter max-w-[1180px]">
    <div className="mb-2 flex items-baseline gap-4">
      <h2 className="font-heading text-[40px] font-medium tracking-[-0.02em]">
        The garage
      </h2>
      <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
        Everything on the bench, at once
      </span>
    </div>

    <p className="mb-7 max-w-[660px] text-[14.5px] text-neutral-500">
      No carousel. A recruiter should be able to scan for the one keyword they
      came for without waiting for it to rotate past.
    </p>

    <div className="grid grid-cols-5 gap-[34px]">
      {GARAGE.map((g) => (
        <div key={g.category}>
          <div className="mb-3.5 flex items-center gap-2.5 border-b border-white/[0.16] pb-2.5">
            <span className="h-0.5 w-3.5 bg-accent" />
            <h3 className="font-heading text-xs font-medium uppercase tracking-[0.16em] text-neutral-300">
              {g.category}
            </h3>
          </div>
          <ul className="flex flex-wrap gap-1.5">
            {g.items.map((item) => (
              <li key={item} className="chip">{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="mt-9 flex gap-9 border-t border-white/[0.16] pt-[18px]">
      <div className="max-w-[420px]">
        <p className="mb-2 text-[10.5px] uppercase tracking-[0.2em] text-accent-300">
          In development
        </p>
        <p className="text-[13.5px] leading-[1.6] text-neutral-400">
          Agentic AI applications — tool-calling services, retrieval pipelines,
          and AI-assisted delivery inside a normal JVM stack.
        </p>
      </div>
      <div className="max-w-[420px]">
        <p className="mb-2 text-[10.5px] uppercase tracking-[0.2em] text-neutral-500">
          How I pick
        </p>
        <p className="text-[13.5px] leading-[1.6] text-neutral-400">
          Boring where it counts, sharp where it pays. The best engineering
          solves a real business problem simply enough that the next person can
          maintain it.
        </p>
      </div>
    </div>
  </section>
);

export default GarageSection;
